import withEntity from '@/entity/components/with-entity';
import OnboardingPanel from './onboarding-panel';

export default withEntity(OnboardingPanel);
